'use strict';function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const BaseService=require('../../../dist-es6/client/angularCommon/baseService');
const GroupBasedDataService=require('../../../dist-es6/client/services/groupBasedDataService');
const GroupTreeService=require('../../../dist-es6/client/services/groupTreeService');
const NosisDisplaySettingsService=require('../../../dist-es6/client/services/nosisDisplaySettingsService');
const DisplaySettingsService=require('../../../dist-es6/client/services/displaySettingsService');
const PersonalIncidentsService=require('../../../dist-es6/client/services/personalIncidentsService');let

GroupBasedDataHelperService=function(_BaseService){_inherits(GroupBasedDataHelperService,_BaseService);
function GroupBasedDataHelperService(dashboardDataService,fatigueTrendsDataService,fleetIncidentsDataService,forecastDataService,groupTreeService,displaySettingsService,personalIncidentsService){_classCallCheck(this,GroupBasedDataHelperService);var _this=_possibleConstructorReturn(this,
_BaseService.call(this));
_.ensureInstanceOf(GroupBasedDataService,dashboardDataService);
_.ensureInstanceOf(GroupBasedDataService,fatigueTrendsDataService);
_.ensureInstanceOf(GroupBasedDataService,fleetIncidentsDataService);
_.ensureInstanceOf(GroupBasedDataService,forecastDataService);
_.ensureInstanceOf(GroupTreeService,groupTreeService);
_.ensureInstanceOf(PersonalIncidentsService,personalIncidentsService);




_.ensureInstanceOf(DisplaySettingsService,displaySettingsService);


_this._dataServices=[
dashboardDataService,
fatigueTrendsDataService,
fleetIncidentsDataService,
forecastDataService];


_this._groupTreeService=groupTreeService;
_this._displaySettingsService=displaySettingsService;
_this._personalIncidentsService=personalIncidentsService;return _this;
}GroupBasedDataHelperService.prototype.

_performOnAllServices=function _performOnAllServices(fn){
_.ensureInstanceOf(Function,fn);

for(const service of this._dataServices){
fn(service);
}
};GroupBasedDataHelperService.prototype.

clearCaches=function clearCaches(){
this._performOnAllServices(function(s){return s.clearCache()});
};GroupBasedDataHelperService.prototype.

updateFatigueMeterType=function updateFatigueMeterType(newFatigueMeterType){
this._performOnAllServices(function(s){return s.fatigueMeterType=newFatigueMeterType});
};GroupBasedDataHelperService.prototype.

clearAllDataServices=function clearAllDataServices(){
this._performOnAllServices(function(s){return s.clearAll()});
};GroupBasedDataHelperService.prototype.

resetAllData=function resetAllData(){
this._groupTreeService.reset();
this._displaySettingsService.reset();
this._personalIncidentsService.reset();
this.clearAllDataServices();
this.updateFatigueMeterType(null);
};return GroupBasedDataHelperService}(BaseService);


module.exports=GroupBasedDataHelperService;
//# sourceMappingURL=groupBasedDataHelperService.js.map
